<template>
  <InteractionStep :disabled-next="isDisabledNext"
                   :pending-next="pendingSave"
                   @next="onSave"
  >
    <template v-slot:content>
      <div class="step-transfer">
        <h3 class="step-transfer__title">{{$tInteraction('Are you organizing a transfer?')}}</h3>
        <transition name="fade" mode="out-in">
          <div v-if="windowSizeMixin.width > 767 && inputs.transfer.value"
               key="inputs"
               class="step-transfer__content">
            <div class="step-transfer__tabs">
              <button type="button" class="step-transfer__btn _yes"
                      :class="{'_active': inputs.transfer.value === 1}"
                      @click.prevent="onClickTab(1)"
              >
                <BaseSvg name="ico-check" width="1.3rem" height="1.9rem"/>
                <span>{{ $tInteraction('Yes') }}</span>
              </button>

              <button type="button" class="step-transfer__btn _no"
                      :class="{'_active': inputs.transfer.value === 2}"
                      @click.prevent="onClickTab(2)"
              >
                <BaseSvg name="ico-close" width="1rem" height="1rem"/>
                <span>{{ $tInteraction('No') }}</span>
              </button>
            </div>
            <div class="step-transfer__inputs" :class="inputsSelector">
              <div class="step-transfer__inputs-head">
                <h4 class="step-transfer__inputs-title">{{ $tInteraction('Where will you meet future employees') }}</h4>
              </div>
              <div class="step-transfer__inputs-wrap">
                <div class="step-transfer__inputs-container">
                  <BaseInput :label="$tInteraction('City')"
                             v-model="inputs.city.value"
                             :error="inputs.city.error"
                             class="step-transfer__input-item  _label-height"
                  />
                  <BaseInput :label="$tInteraction('Street')"
                             v-model="inputs.street_name.value"
                             :error="inputs.street_name.error"
                             class="step-transfer__input-item  _label-height"
                  />
                  <BaseInput :label="$tInteraction('House number')"
                             v-model="inputs.street_number.value"
                             :error="inputs.street_number.error"
                             class="step-transfer__input-item  _label-height"
                  />
                  <div class="step-transfer__input-item">
                    <DatePiker :label="$tInteraction('Arrival date')"
                               v-model="inputs.data.value"
                               :error="inputs.data.error"
                               :disabled-date="notBeforeToday"
                               class=" _green"
                    />
                  </div>
                  <div class="step-transfer__input-item">
                    <div class="step-transfer__label">{{ $tInteraction('Time') }}</div>
                    <div class="step-transfer__time">
                      <BaseInput v-model="inputs.time_hours.value"
                                 :min="0"
                                 :max="24"
                                 mask="##"
                                 :class="inputs.time_hours.error ? '_error' : null"
                                 class="step-transfer__time-input"
                      />
                      <span>:</span>
                      <BaseInput v-model="inputs.time_minutes.value"
                                 :min="0"
                                 :max="59"
                                 mask="##"
                                 :class="inputs.time_minutes.error ? '_error' : null"
                                 class="step-transfer__time-input"
                      />
                    </div>
                    <BaseInputError :value="inputs.time_hours.error || inputs.time_minutes.error"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else
               key="buttons"
               class="step-transfer__buttons">

            <button type="button" class="step-transfer__btn _yes"
                    @click.prevent="onClickTab(1)"
                    :class="{'_active': inputs.transfer.value === 1}"
            >
              <BaseSvg name="ico-check" width="1.3rem" height="1.9rem"/>
              <span>{{ $tInteraction('Yes') }}</span>
            </button>

            <collapse-transition>
              <div v-if="inputs.transfer.value === 1" class="step-transfer__inputs">
                <div class="step-transfer__inputs-head">
                  <h4 class="step-transfer__inputs-title">{{ $tInteraction('Where will you meet future employees') }}</h4>
                </div>
                <div class="step-transfer__inputs-wrap">
                  <div class="step-transfer__inputs-container">
                    <BaseInput :label="$tInteraction('City')"
                               v-model="inputs.city.value"
                               :error="inputs.city.error"
                               class="step-transfer__input-item "
                    />
                    <BaseInput :label="$tInteraction('Street')"
                               v-model="inputs.street_name.value"
                               :error="inputs.street_name.error"
                               class="step-transfer__input-item  _label-height"
                    />
                    <BaseInput :label="$tInteraction('House number')"
                               v-model="inputs.street_number.value"
                               :error="inputs.street_number.error"
                               class="step-transfer__input-item  _label-height"
                    />
                    <div class="step-transfer__input-item">
                      <DatePiker :label="$tInteraction('Arrival date')"
                                 v-model="inputs.data.value"
                                 :error="inputs.data.error"
                                 :disabled-date="notBeforeToday"
                                 class=" _green"
                      />
                    </div>
                    <div class="step-transfer__input-item">
                      <div class="step-transfer__label">{{ $tInteraction('Time') }}</div>
                      <div class="step-transfer__time">
                        <BaseInput v-model="inputs.time_hours.value"
                                   :min="0"
                                   :max="24"
                                   mask="##"
                                   :class="inputs.time_hours.error ? '_error' : null"
                                   class="step-transfer__time-input"
                        />
                        <span>:</span>
                        <BaseInput v-model="inputs.time_minutes.value"
                                   :min="0"
                                   :max="59"
                                   mask="##"
                                   :class="inputs.time_minutes.error ? '_error' : null"
                                   class="step-transfer__time-input"
                        />
                      </div>
                      <BaseInputError :value="inputs.time_hours.error || inputs.time_minutes.error"/>
                    </div>
                  </div>
                </div>
              </div>
            </collapse-transition>


            <button type="button" class="step-transfer__btn _no"
                    @click.prevent="onClickTab(2)"
                    :class="{'_active': inputs.transfer.value === 2}"
            >
              <BaseSvg name="ico-close" width="1rem" height="1rem"/>
              <span>{{$tInteraction('No') }}</span>
            </button>

            <collapse-transition>
              <div v-if="inputs.transfer.value === 2" class="step-transfer__inputs">
                <div class="step-transfer__inputs-head">
                  <h4 class="step-transfer__inputs-title">{{ $tInteraction('Where will you meet future employees') }}</h4>
                </div>
                <div class="step-transfer__inputs-wrap">
                  <div class="step-transfer__inputs-container">
                    <BaseInput :label="$tInteraction('City')"
                               v-model="inputs.city.value"
                               :error="inputs.city.error"
                               class="step-transfer__input-item  _label-height"
                    />
                    <BaseInput :label="$tInteraction('Street')"
                               v-model="inputs.street_name.value"
                               :error="inputs.street_name.error"
                               class="step-transfer__input-item  _label-height"
                    />
                    <BaseInput :label="$tInteraction('House number')"
                               v-model="inputs.street_number.value"
                               :error="inputs.street_number.error"
                               class="step-transfer__input-item  _label-height"
                    />
                    <div class="step-transfer__input-item">
                      <DatePiker :label="$tInteraction('Arrival date')"
                                 v-model="inputs.data.value"
                                 :error="inputs.data.error"
                                 :disabled-date="notBeforeToday"
                                 class=" _green"
                      />
                    </div>
                    <div class="step-transfer__input-item">
                      <div class="step-transfer__label">{{ $tInteraction('Time') }}</div>
                      <div class="step-transfer__time">
                        <BaseInput v-model="inputs.time_hours.value"
                                   :min="0"
                                   :max="24"
                                   mask="##"
                                   :class="inputs.time_hours.error ? '_error' : null"
                                   class="step-transfer__time-input"
                        />
                        <span>:</span>
                        <BaseInput v-model="inputs.time_minutes.value"
                                   :min="0"
                                   :max="59"
                                   mask="##"
                                   :class="inputs.time_minutes.error ? '_error' : null"
                                   class="step-transfer__time-input"
                        />
                      </div>
                      <BaseInputError :value="inputs.time_hours.error || inputs.time_minutes.error"/>
                    </div>
                  </div>
                </div>
              </div>
            </collapse-transition>

          </div>


        </transition>

      </div>
      <BaseAlert :value="error" class="step-information__error  _error"/>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '@/axios';
  import formMixins from '../../../mixins/formMixins';
  import InteractionStep from '../InteractionStep';
  import DatePiker from '../../DatePiker';
  import BaseInputError from '../../BaseInputError';
  import windowSizeMixin from '../../../mixins/windowSizeMixin';
  import {CollapseTransition} from 'vue2-transitions';
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  // export function timeMask(value) {
  //   const hours = [
  //     /[0-2]/,
  //     value.charAt(0) === '2' ? /[0-3]/ : /[0-9]/,
  //   ];
  //   const minutes = [/[0-5]/, /[0-9]/];
  //   return value.length > 2
  //       ? [...hours, ':', ...minutes]
  //       : hours;
  // }
  //
  // /**
  //  * Generate a time range mask based on input value (00:00-23:59)
  //  * @param {string} value
  //  */
  // export function timeRangeMask(value) {
  //   const numbers = value.replace(/[^0-9]/g, '');
  //   if (numbers.length > 4) {
  //     return [...timeMask(numbers.substring(0, 4)), '-', ...timeMask(numbers.substring(4))];
  //   }
  //   return [...timeMask(numbers)];
  // }

  export default {
    name: 'InteractionStepArrivalInfo',
    mixins: [formMixins, windowSizeMixin, interactionStepMixin],
    components: {
      BaseInputError,
      InteractionStep,
      DatePiker,
      CollapseTransition
    },
    data() {
      return {
        error: null,
        pendingSave: false,
        inputs: {
          data: {
            value: null,
            required: true
          },
          time_hours: {
            value: null,
            required: true
          },
          time_minutes: {
            value: null,
            required: true
          },
          city: {
            value: null,
            required: true
          },
          street_name: {
            value: null,
            required: true
          },
          street_number: {
            value: null,
            required: true
          },
          transfer: {
            value: null,
            required: true
          }
        }
      };
    },
    computed: {
      inputsSelector() {
        return {
          '_left': this.inputs.transfer.value === 1,
          '_right': this.inputs.transfer.value === 2
        }
      },
      isDisabledNext() {
        const inputs = this.inputs
        for (const key in inputs) {
          if(inputs[key].required && !inputs[key].value) {
            return true
          }
        }

        return false
      },

      // - - - -

      // maskHours() {
      //   const h = this.inputs.time_hours.value
      //   const second = h && h.charAt(0) === '2'
      //       ? /[0-3]/
      //       : /[0-9]/
      //   return [
      //     /[0-2]/,
      //     second
      //   ];
      // },
      // maskMinutes() {
      //   return [/[0-5]/, /[0-9]/];
      // }
    },
    methods: {
      onSave() {
        this.error = null;

        const step = this.$store.state.interaction.step;
        this.resetErrorsMix(this.inputs);
        const sendData = this.createSendDataMix(this.inputs);
        if (this.isRequiredEmptyMix) return

        this.pendingSave = true;

        if (sendData.data) {
          sendData.data.setHours(sendData.time_hours);
          sendData.data.setMinutes(sendData.time_minutes);
        }

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`, sendData).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction');
        }).catch(e => {
          this.errorHandlerMix(e, this.inputs);
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false;
        });
      },
      onClickTab(num) {
        this.inputs.transfer.value = num;
      },
      notBeforeToday(date) {
        return date < new Date(new Date().setHours(0, 0, 0, 0));
      },

    }
  };


  // function timeMask(value) {
  //   const hours = [
  //     /[0-2]/,
  //     value.charAt(0) === '2' ? /[0-3]/ : /[0-9]/,
  //   ];
  //   const minutes = [/[0-5]/, /[0-9]/];
  //   return value.length > 2
  //       ? [...hours, ':', ...minutes]
  //       : hours;
  // }
  //
  // /**
  //  * Generate a time range mask based on input value (00:00-23:59)
  //  * @param {string} value
  //  */
  // function timeRangeMask(value) {
  //   const numbers = value.replace(/[^0-9]/g, '');
  //   if (numbers.length > 4) {
  //     return [...timeMask(numbers.substring(0, 4)), '-', ...timeMask(numbers.substring(4))];
  //   }
  //   return [...timeMask(numbers)];
  // }
</script>

<style>

</style>
